var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}},_vm._l((_vm.posts),function(post,idx){return _c('div',{key:idx})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }